module.exports = "https://cdn.hellotech.com/client-assets/yale_locks_desktop_3c585a4e29b258018f03e913b5f417a8.webp";